import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Button } from '@datanomik/core-ui';

import { LoadingPageNew } from '../LoadingPageNew';

const CANCEL_LINK_DELAY_MS = 8000;
interface SsoRedirectProps {
  onCancel: (...args: any[]) => any;
}

export const SsoRedirect = ({ onCancel }: SsoRedirectProps) => {
  const [showCancel, setShowCancel] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowCancel(true), CANCEL_LINK_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <LoadingPageNew
      message={t('Redirecting to your organization login')}
      footer={showCancel && (
        <Button variant="link" onClick={onCancel}>{t('Back to login')}</Button>
      )}
    />
  );
};
